import mixpanel from "mixpanel-browser";
import { EVENT_PREFIX } from "./tracker";

export const initializeMixPanel = (token?: string, debug: boolean = false) => {
  if (token) {
    // entriweb registers learner super properties (free_trial, gold_user, lead_score, ...) in
    // mixpanel's default cookie, shared across *.entri.app. A cookie of our own keeps them off
    // streamline events, and keeps streamline's register/reset off the learner app's.
    mixpanel.init(token, { debug, persistence_name: EVENT_PREFIX });
  } else {
    console.log("token not passed - MixPanel Init");
  }
};

/**
 * Cleans up the payload by removing keys with null, undefined, or empty string values
 * Preserves valid falsy values like 0 and false
 */
const cleanupPayload = (payload: Record<string, unknown>): Record<string, unknown> => {
  return Object.entries(payload).reduce((acc, [key, value]) => {
    // Keep 0 and false as they are valid values
    if (value !== null && value !== undefined && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, unknown>);
};

/**
 * @param event_name
 * @param payload
 */
export const sendMixpanelEvent = (name: string, payload = {}) => {
  const eventName = EVENT_PREFIX + '_' + name;
  const cleanedPayload = cleanupPayload(payload);

  if (process.env.NODE_ENV === "development") {
    console.log(eventName, cleanedPayload, 'MIXPANEL EVENT')
  } else {
    mixpanel.track(eventName, cleanedPayload);
  }
};

export const identifyMixpanel = (userId: number) => {
  mixpanel.identify(`${userId}`);
};

export const mixpanelUnRegister = (name: string) => {
  mixpanel.unregister(name);
};

export const mixpanelInrementValue = (property: string, value: number) => {
  mixpanel.people.increment(property, value);
};

export const mixpanelUserLogout = () => {
  mixpanel.reset();
};

export const mixpanelLoginRegister = (user: any) => {
  mixpanel.identify(`${user?.id}`);
  mixpanel.people.set({
    user_id: user.id,
    username: user.username,
    app_platform: "streamline",
    user_role: user.role,
  });
  mixpanel.register({
    app_platform: "streamline",
    username: user.username,
    user_id: user.id,
  });
};